import React, { FC, useCallback, useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { StakingBaskets } from './StakingBaskets'
import { Stake } from './Stake'
import { CurrentPortfolio } from './CurrentPotrfolio'
import { Balance } from './Balance'
import { History } from './History'
import { GridRow } from '../../../../components/GridRow'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}))

export const Staking: FC = () => {
  const classes = useStyles()

  const [assets, setAssets] = useState<Array<string>>([])

  const getAssets = useCallback((assetsArray: Array<string>) => {
    if (assetsArray) setAssets(assetsArray)
  }, [])

  return (
    <Box className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h1">Staking</Typography>
      </Grid>
      <GridRow spacing={4}>
        <Grid item xs={6}>
          <StakingBaskets title={'Staking Baskets'} getAssets={getAssets} />
        </Grid>
        <Grid item xs={6}>
          <Stake title={'Stake'} assets={assets} />
        </Grid>
      </GridRow>

      <GridRow spacing={4}>
        <Grid item xs={6}>
          <CurrentPortfolio title={'Current Portfolio'} />
        </Grid>
        <Grid item xs={6}>
          <Balance title={'Balance Available for Staking'} />
        </Grid>
      </GridRow>

      <GridRow spacing={4}>
        <Grid item xs={12}>
          <History title={'Staking History'} />
        </Grid>
      </GridRow>
    </Box>
  )
}
